import React, { useState } from "react";
import InformationCard, { InformationTextAlign } from "./InformationCard";
import styles from "./InformationSection.module.css";

import TwoToneHorizontalSectionChild from "./TwoToneHorizontalSectionChild";
import clsx from "clsx";

interface InformationSectionProps {
  titleTone1: string;
  titleTone2: string;
  description: string;
  items: {
    title: string;
    description: string;
    buttonName: string;
    srcImage: string[];
    informationAlignment: InformationTextAlign;
    onClickAction: () => void;
    isDisable?: boolean;
  }[];
  isHovered?: boolean;
  moveBottomImageTop?: boolean | null;
}

const InformationSection: React.FC<InformationSectionProps> = ({
  titleTone1,
  titleTone2,
  description,
  items,
  isHovered = false,
  moveBottomImageTop = false,
}) => {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  return (
    <div className={styles["parent-container"]}>
      <TwoToneHorizontalSectionChild
        titleTone1={titleTone1}
        titleTone2={titleTone2}
        description={description}
      >
        <div
          className={clsx(
            styles["grid-container"],
            isHovered && styles["grid-container-hover"]
          )}
        >
          {items.map((item, index) => (
            <div
              key={index}
              className={styles["item-container"]}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <InformationCard
                key={index}
                title={item.title}
                paragraph={item.description}
                srcImage={item.srcImage}
                buttonName={item.buttonName}
                informationTextAlign={item.informationAlignment}
                onClick={item.onClickAction}
                isDisable={item.isDisable}
                moveBottomImageTop={moveBottomImageTop}
                isHovered={hoveredIndex == index}
              />
            </div>
          ))}
        </div>
      </TwoToneHorizontalSectionChild>
    </div>
  );
};

export default InformationSection;
